import Types from '../../action/types';

const defaultState = {
    loading: false,
    org:[],
    // tableLoading:false,
};

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.P_ORG:
            return {
                ...state,
                org:action.org
                // tableData: action.tableData,
                // tableLoading:true
            };
        case Types.P_ORG_CLEAR:
            return {
                ...state,
                org:action.org
            };
        
        default:
            return state;
    }
}